define('app/helpers/map-helpers',['jquery', 'leaflet', 'lib/showdown', 'lib/coordfinder/coordfinder'], function(
  $,
  L,
  showdown,
  CoordFinder
) {
  return {
    createMapObject: createMapObject,
    randomID: randomID,
    calculateZIndex: calculateZIndex,
    serializeCoordinate: serializeCoordinate,
    fromShowdownToHtml: fromShowdownToHtml,
    convertTransparencyToOpacity: convertTransparencyToOpacity,
    getCoordinatesAsText: getCoordinatesAsText,
    copyStringToClipboard: copyStringToClipboard,
    getQueryStringAsObject: getQueryStringAsObject,
    getCRS3006: getCRS3006,
    formatForPrint: formatForPrint,
  };

  function createMapObject(mapDivId, config, queryParams) {
    var isLocalhost =
      document.location.protocol.indexOf('file') > -1 ||
      document.location.hostname.indexOf('localhost') > -1;
    var isTopWindow = window.parent === window;
    var isMobile = L.Browser.mobile;

    var map = L.map(mapDivId, {
      zoomControl: false,
      dragging: isTopWindow || queryParams.lightbox || !isMobile,
      gestureHandling: !(queryParams.lightbox || isTopWindow),
      tap: !isMobile, // Due to Leaflet bug
      touchZoom: true,
      maxZoom: config.maxZoomLevel,
      minZoom: config.minZoomLevel,
      crs: config.crs === 'EPSG:3006' ? getCRS3006() : L.CRS.EPSG3857,
      continuousWorld: true,
      worldCopyJump: false,
      scrollWheelZoom: isTopWindow || queryParams.lightbox,
      contextmenu: isLocalhost ? false : true, // disable on localhost to allow right click > inspect
      contextmenuWidth: 200,
      contextmenuItems: [
        {
          text: 'Visa koordinater',
          callback: function(e) {
            var text = getCoordinatesAsText(e);
            map.openPopup(text, e.latlng);
          },
        },
        {
          text: 'Kopiera koordinater till Urklipp',
          callback: function(e) {
            var text = getCoordinatesAsText(e).replace(/<br>/g, '\n');
            copyStringToClipboard(text);
          },
        },
      ],
    });

    if (!isMobile) {
      map
        .on('focus', function() {
          // Enable wheel zoom on focus
          map.scrollWheelZoom.enable();
        })
        .on('blur', function() {
          map.scrollWheelZoom.disable();
        });
    }

    return map;
  }

  function randomID() {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  function calculateZIndex(prio) {
    // Prio, 1 is most prioritzed, higher values gets lower priority
    return 650 - prio; // Make sure resulting zIndex is lower than tooltipPane's zIndex (650)
  }

  function serializeCoordinate(coordinate) {
    return coordinate.lat + ',' + coordinate.lng;
  }

  // Convert showdown text to html
  function fromShowdownToHtml(text) {
    text = text.replace(/<br\/\>/g, '\n'); // Convert br tags to newlines

    var converter = new showdown.Converter();
    converter.setOption('disableForced4SpacesIndentedSublists', true);
    converter.setOption('openLinksInNewWindow', true);
    converter.setOption('simplifiedAutoLink', true);

    var str = converter.makeHtml(text);
    //Remove p tag ... (why? /Bernt)
    str = str.replace(/(<p[^>]+?>|<\/p>|<\/p>)/, '');
    str = str.replace(/(<p[^>]+?>|<p>|<\/p>)/, '');

    return str;
  }

  // leaflet supports opacity: 0.75, but in our config, we use transparency: 25
  function convertTransparencyToOpacity(transparency) {
    if (!transparency) {
      return 1;
    }

    return (100 - transparency) / 100;
  }

  function getCoordinatesAsText(e) {
    var point = CoordFinder.pointIn(e.latlng.lat + ', ' + e.latlng.lng);
    if (!point) {
      return;
    }

    var refsys = CoordFinder.RefSys.SWEREF99TM;
    var outputHtml = '';
    outputHtml += point.asText({ format: 'degreesandminutes' }) + '<br>';
    outputHtml += point.asText() + '<br>';

    var asSweRef99Tm = point.reprojectTo(refsys);
    if (asSweRef99Tm) {
      outputHtml += asSweRef99Tm.asText();
    }

    return outputHtml;
  }

  function copyStringToClipboard(str) {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
  }

  function getQueryStringAsObject(str) {
    // location.search = "?position=..&zoom=9&mode=print&filter=tags"
    return !str.length
      ? {}
      : str
          .split('&')
          .map(function(ps) {
            return ps.split('=').map(function(c) {
              return decodeURIComponent(c);
            });
          })
          .reduce(function(o, param) {
            o[param[0]] = param[1];
            return o;
          }, {});
  }

  function getCRS3006() {
    return new L.Proj.CRS(
      'EPSG:3006',
      '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      {
        resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
        origin: [0, 0],
      }
    );
  }

  function formatForPrint(title, description) {
    document.title = 'Utskrift';
    $('.webgis-container')
      .prepend(
        '<h1>' +
          title +
          '</h1>' +
          '<button class="hav-button" onclick="window.print()">Skriv ut</button>'
      )
      .append('<div class="hav-print-desc">' + description + '</div>');

    // Leave room for title and description, and no wider than A4 page in portrait mode
    $('.webgis-container-div')
      .addClass('webgis-container-div--print')
      .height('80%')
      .width('calc(210mm - 20mm)');
  }
});

